import React, { useState, useContext } from "react";
import {
    UiAuthContainer,
    UiAuthFooterContainer,
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

import ResetPassword from "../auth/forms/ResetPassword";
import { participantUrl } from "../../../_redux/_constants";
export default function ResetPasswordWrapper(props) {
    const hostname = window.location.hostname
        .replace(".com", "")
        .split(".")
        .pop();
    const isTlc = hostname === participantUrl.RENAULT_TLC_URL;
    return (
        <>
            <UiAuthContainer>
                <div className={isTlc ? "sb-auth-top-wr sb-auth-top-wr-top-tlc" : "sb-auth-top-wr sb-auth-top-wr-top"}>
                    <h2>Reset Password</h2>
                    <ResetPassword />
                    <UiAuthFooterContainer />
                </div>
            </UiAuthContainer>
        </>
    );
}
